import React, { createElement } from "react"
import { Link } from "gatsby";

export default function Breadcrumb({ breadcrumb, background, currentPage, isMenuItem }) {
  const BreadcrumbWrapper = (breadcrumb) => createElement((breadcrumb.url === "#") ? "span" : Link, breadcrumb)
  return (
    <BreadcrumbWrapper to={breadcrumb.url} target={breadcrumb.target || breadcrumb.url?.startsWith("/") ? "_self" : "_blank"} rel={breadcrumb.url?.startsWith("/") ? "" : `noreferrer`}
      className={`uppercase tracking-[.2em] font-bold inline-block
    ${background === "dark" ? "md:btn-green-50" : background === "green" || background === "red" ? "text-white"
          : background === "hotel" ? `text-slate ` 
          : "text-green"} 
          ${isMenuItem ? `py-2 border-b hover:border-b-purple ${currentPage === breadcrumb.url ? "border-b-purple" : "border-b-transparent"}`: ""}`}>
      {breadcrumb.title}
    </BreadcrumbWrapper>
  )
}
